import { createAsyncThunk } from '@reduxjs/toolkit'
import { createGenericSlice } from '../../../../../utils/slices'

import { DEFAULT_HANGER_ANGLE_VALUES, DEFAULT_TOP_FLANGE_VALUES } from '../../../common/constants'
import { $post } from '../../../../../utils/apis'

const initialState = {
  ...DEFAULT_TOP_FLANGE_VALUES,
  ...DEFAULT_HANGER_ANGLE_VALUES,
}

const getSascData = createAsyncThunk('hanger/sasc', async (body = {}, { rejectWithValue }) => {
  try {
    const response = await $post('/webapps/SlopeSkew/HipValleyCalculator.ashx', body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const hangerSlice = createGenericSlice({
  name: 'hangerOptions',
  initialState,
  reducers: {
    resetHangerState: () => {
      return { ...initialState }
    },
    resetTopFlangeState: (state) => {
      return { ...state, ...DEFAULT_TOP_FLANGE_VALUES }
    },
  },
})

export const hangerActions = { ...hangerSlice.actions, getSascData }
